import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { useAppDispatch, useAppSelector } from 'modules/Editor/store';
import { selectImagePanelTabIndex } from 'modules/Editor/store/editorSettingsSelector';
import { setImagePanelTabIndex } from 'modules/Editor/store/editorSettingsSlice';
import { ReactElement, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { NewWidget } from 'widgets/Widget.types';

import { PhotoWidgetMenu } from '../PhotoWidgetMenu';
import { PhotoWidgetMenuCategory } from '../PhotoWidgetMenu/PhotoWidgetCategory';

interface ImagesMenuProps {
  allowNavFocus?: boolean;
  onItemClick: (widget: NewWidget | NewWidget[]) => void;
}

const UPLOADS_TAB_INDEX = 0;
const PHOTOS_TAB_INDEX = 1;

export const ImagesWidgetMenu = ({ allowNavFocus, onItemClick }: ImagesMenuProps): ReactElement => {
  const activeTab = useAppSelector(selectImagePanelTabIndex);
  const dispatch = useAppDispatch();

  const { t } = useTranslation('editor_widget_menu', { useSuspense: false, keyPrefix: 'sideMenu' });

  const boxShadow = allowNavFocus ? 'inset var(--vg-shadows-outline)' : 'none';

  const onChangeTabs = useCallback(
    (index: number) => {
      dispatch(setImagePanelTabIndex(index));
    },
    [dispatch],
  );

  return (
    <Box>
      <Tabs onChange={onChangeTabs} index={activeTab}>
        <TabList h='48px' px='4'>
          <Tab
            fontSize='sm'
            fontWeight='semibold'
            _focus={{ boxShadow }}
            bg={activeTab === UPLOADS_TAB_INDEX ? 'var(--vg-colors-hover-blue)' : 'unset'}
            px='3'
          >
            {t('imagesMenu.uploads')}
          </Tab>
          <Tab
            fontSize='sm'
            fontWeight='semibold'
            _focus={{ boxShadow }}
            bg={activeTab === PHOTOS_TAB_INDEX ? 'var(--vg-colors-hover-blue)' : 'unset'}
            px='3'
          >
            {t('imagesMenu.imageLibrary')}
          </Tab>
        </TabList>
        <TabPanels overflowY={'auto'} height={'calc(100vh - 10rem)'}>
          <TabPanel padding='0' _focus={{ boxShadow }} height='100%'>
            <PhotoWidgetMenuCategory onItemClick={onItemClick} isMenuActive={activeTab === UPLOADS_TAB_INDEX} />
          </TabPanel>
          <TabPanel padding='0' _focus={{ boxShadow }} height='100%'>
            <PhotoWidgetMenu onItemClick={onItemClick} isMenuActive={activeTab === PHOTOS_TAB_INDEX} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};
